import type { SearchMenuSearchProps } from "./types-search";
import { useSearchMenuSearch } from "./use-search";
import { SearchMenuSearchView } from "./view-search";

export function SearchMenuSearch(props: SearchMenuSearchProps) {
  const viewModel = useSearchMenuSearch(props);

  return <SearchMenuSearchView {...viewModel} />;
}
SearchMenuSearch.displayName = "SearchMenu.Search";
